import { ReactTyped } from "react-typed";

export const UiLetterAnimation = ({ text, typingSpeed = 60 }) => {
  return <ReactTyped strings={[text]} typeSpeed={typingSpeed} />;
};
